/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ShowInvitationResponse = zod
	.object({
		email: zod.email().describe('Invitee email'),
		expires_at: zod.iso.datetime({ offset: true }).describe('Expiration timestamp'),
		full_name: zod.string().nullable().describe('Invitee full name'),
		id: zod.string().describe('Invitation ID'),
		organization: zod
			.object({
				created_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				id: zod.uuid().describe('Organization ID'),
				name: zod.string().describe('Organization name'),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
			})
			.describe('An organization'),
		role: zod.enum(['owner', 'member']),
		status: zod.enum(['pending', 'accepted', 'revoked', 'expired'])
	})
	.describe('Invitation details for acceptance page');

export type ShowInvitationResponse = zod.input<typeof ShowInvitationResponse>;
export type ShowInvitationResponseOutput = zod.output<typeof ShowInvitationResponse>;
